<template>
  <div class="account-troubleshooting-reasons-modal">
    <snappy-green-modal :open="open" @close="$emit('close')">
      <template v-slot:header>
        <div v-if="report" class="account-troubleshooting-reasons-modal__header">
          <span><strong>Sync ID: </strong>{{ report.id }}</span>
          <span><strong>Date: </strong>{{ reportDate }}</span>
          <span><strong>Status: </strong>{{report.success ? 'Completed' : 'Incomplete'}}</span>
        </div>
      </template>
      <div class="account-troubleshooting-reasons-modal__subheader">Possible Reasons:</div>
      <ul class="account-troubleshooting-reasons-modal__items">
        <li v-for="(value, key, index) in items" :key="index" class="account-troubleshooting-reasons-modal__item">
          <div v-html="key" class="account-troubleshooting-reasons-modal__event"></div>
          <ol>
            <li v-for="(reason, index) of value" :key="index">{{reason}}</li>
          </ol>
        </li>
      </ul>
      <template v-slot:footer>
        <div class="account-troubleshooting-reasons-modal__footer">
          <strong>Still need help?</strong>
          <div @click="$emit('contact')" >
            <button class="btn btn-outline-primary">
              {{ 'Click Here to Contact Support' }}
            </button>
          </div>
        </div>
      </template>
    </snappy-green-modal>
  </div>
</template>

<script>
import SnappyGreenModal from '../../../components/SnappyGreenModal';
import {convertServerDateToLocalMoment} from '../../../utility/date/date-converter';

export default {
  name: 'account-troubleshooting-reasons-modal',
  components: {SnappyGreenModal},
  props: {
    open: {
      type: Boolean,
      required: true,
    },   
    report: {
      type: Object | null,
      required: true,
    },
    accountTroubleshootingReasons: {
      type: Object,
      required: true,
    },
    timezone: {
      type: String,
      required: true,
    },
  },
  computed: {
    reportDate() {
      return convertServerDateToLocalMoment(this.report.started_at, undefined, this.timezone).format('DD/MM/YY');
    },     
    items() {      
      const mappedTroubles = this.report?.troubleshooting?.map(item => Object.keys(this.accountTroubleshootingReasons).includes(item) ? item.toLowerCase() : 'unknown error');         
      return Object.keys(this.accountTroubleshootingReasons).reduce((acc, cur) => {
        if(mappedTroubles && mappedTroubles.includes(cur.toLowerCase())) {
          acc[cur] = this.accountTroubleshootingReasons[cur];
        }
        return acc;
      }, {})
    }
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../sass/web/_variables.scss';

.account-troubleshooting-reasons-modal {
  &__header {
    display: flex;
    justify-content: space-between;
  }
  &__subheader {
    font-weight: 600;
  }
  &__items {
    color: #8f98ac;
    line-height: 20px;
    padding-left: 25px;
    max-height: 300px;
    overflow-y: auto;
    margin: 0;
    &::-webkit-scrollbar {
      width: 7px;
      height: 72px;
    }

    &::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 16px $white-color;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #bfc5d2;
      border-radius: 20px;
      border: 3px solid #bfc5d2;
      height: 72px;
    }
  }
  &__item {
    &:only-of-type { list-style-type: none; }
  }
  &__event {
    font-weight: bold;
    margin: 10px 0 5px;
  }
  &__footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>
